import { Component, OnInit } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';

@Component({
  selector: 'vit-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit {

  showWinningPlan: boolean = false;
  showDrawingHistory: boolean = false;
  showTicketHistory: boolean = false;

  constructor(public sessionService: SessionService) {
  }

  ngOnInit() {
  }

  closePopups() {
    this.showWinningPlan = false;
    this.showDrawingHistory = false;
    this.showTicketHistory = false;
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/menu-bar/menu-bar.component.ts